import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import './Dialog_Cockpit.scss';
import { generalId, ProtocolListAssignment } from '@app/advisor-shared';
import { filterInstances } from '@nu-art/ts-common';
import { Component_Cockpit_DDX } from '../../components/cockpit/cockpit-ddx/Component_Cockpit_DDX.js';
import { ModuleFE_Advisor_ColorGroup, ModuleFE_Advisor_DiseaseProfile, ModuleFE_Advisor_Pathway, ModuleFE_Advisor_PathwayState, ModuleFE_Advisor_PathwayTransition, ModuleFE_Advisor_Variable, ModuleFE_RuntimeFinding, ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { Component_Cockpit_KeyFindings } from '../../components/cockpit/cockpit-key-findings/Component_Cockpit_KeyFindings.js';
import { Component_Cockpit_FindingsHighlight } from '../../components/cockpit/cockpit-findings-highlight/Component_Cockpit_FindingsHighlight.js';
import { DiseasePathwayTypes, pathwayType_SingleState } from '@app/pathway-shared';
import { Component_Cockpit_Vitals } from '../../components/cockpit/cockpit-vitals/Component_Cockpit_Vitals.js';
import { ProtocolData } from '../../../_utils/ProtocolData/ProtocolData.js';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
const dialogKey = 'dialog__cockpit';
export const ModulesToAwait_Cockpit = [
    //Static Modules
    ModuleFE_Advisor_Pathway,
    ModuleFE_Advisor_PathwayState,
    ModuleFE_Advisor_PathwayTransition,
    ModuleFE_Advisor_DiseaseProfile,
    ModuleFE_Advisor_ColorGroup,
    ModuleFE_Advisor_Variable,
    //Runtime Modules
    ModuleFE_RuntimeProtocol,
    ModuleFE_RuntimeFinding,
];
export class Dialog_Cockpit extends ComponentSync {
    //######################### Static #########################
    static show = () => {
        const model = {
            dialogKey: dialogKey,
            content: () => _jsx(Dialog_Cockpit, {}),
            overlayClass: 'blur'
        };
        ModuleFE_Dialog.show(model);
        //Report analytics event
        ModuleFE_AdvisorAnalytics.trigger.cockpit.cockpit_open();
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        const protocols = filterInstances(ModuleFE_RuntimeProtocol.cache.map(protocol => {
            //Filter out general protocol
            if (protocol.variableIds[0] === generalId)
                return;
            // Placement is backend-owned — match regular DDx: only Consider Now.
            if (protocol.listAssignment !== ProtocolListAssignment.CONSIDER_NOW)
                return;
            //Filter out any remaining protocol that isn't a DDx protocol
            const protocolData = ProtocolData.createNew(protocol._id);
            if (([...DiseasePathwayTypes, pathwayType_SingleState]).includes(protocolData?.pathway.type))
                return protocolData;
        }));
        //Sort protocols by score, highest first
        state.protocols = ProtocolData.sort(protocols);
        return state;
    }
    //######################### Logic #########################
    focusDiagnosis = (diagnosisData) => {
        const id = diagnosisData.diagnosis._id === this.state.focusedDiagnosisId ? undefined : diagnosisData.diagnosis._id;
        this.setState({ focusedDiagnosisId: id });
        //Report analytics event
        if (!id)
            return;
        ModuleFE_AdvisorAnalytics.trigger.cockpit.cockpit_ddxFocus({
            protocolId: diagnosisData.protocol._id,
            diagnosisId: diagnosisData.diagnosis._id,
            diagnosisLabel: diagnosisData.diagnosis.name,
        });
    };
    closeDialog = () => {
        ModuleFE_Dialog.close(undefined, dialogKey);
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_H_C, { id: dialogKey, children: [_jsxs(LL_V_L, { className: 'cockpit-panel-column', children: [_jsx(Component_Cockpit_Vitals, {}), _jsx(Component_Cockpit_KeyFindings, { protocols: this.state.protocols, focusedDiagnosisId: this.state.focusedDiagnosisId })] }), _jsx(LL_V_L, { className: 'cockpit-panel-column', children: _jsx(Component_Cockpit_FindingsHighlight, {}) }), _jsx(LL_V_L, { className: 'cockpit-panel-column', children: _jsx(Component_Cockpit_DDX, { protocols: this.state.protocols, focusedDiagnosisId: this.state.focusedDiagnosisId, focusDiagnosis: this.focusDiagnosis, closeDialog: this.closeDialog }) })] });
    }
}
//# sourceMappingURL=Dialog_Cockpit.js.map